export class EditProfileAmbassador {
  profilePicUrl: string = "";
  firstName: string = "";
  lastName: string = "";
  dob: string = "";
  email: string = "";
  gender: string = "";
  phone: string = "";
  address: string = "";
  city: string = "";
  state: string = "";
  zipCode: string = "";
  SkillsStrength: string = "";
  mission: string = "";
  engagement: string = "";
  commitment: string = "";
  ambassadorID: string = "";
  profilePicId:number = 0;
  language:string = "";
}
